import "mutationobserver-shim";
import Vue from "vue";
import "@/plugins/bootstrap-vue";
import "@/plugins/vue-cropper";
import "@/plugins/axios/axios";
import DateUtil from "@/plugins/date-util";
import FilterUtil from "@/plugins/filter-util";
import StringUtil from "@/plugins/string-util";
import TimerUtil from "@/plugins/timer-util";
import { provide } from "@/provide";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store/store";
import "@/errorHandler";
import "@/validator";
import VueScrollTo from "vue-scrollto";
import { registerRouterBeforeEach } from "@/registerRouterBeforeEach";
import { BootstrapVueIcons } from "bootstrap-vue";
import "bootstrap-vue/dist/bootstrap-vue-icons.min.css";
import vueWindowSize from "vue-window-size";

// routerに画面遷移前処理を登録する
registerRouterBeforeEach(router, store);

// 自作プラグインをVueに追加する
Vue.use(DateUtil);
Vue.use(FilterUtil);
Vue.use(StringUtil);
Vue.use(TimerUtil);

// ページ内スクロール用プラグインをVueに追加する
Vue.use(VueScrollTo, {
  duration: 700,
  easing: [0, 0, 0.1, 1],
  offset: -100
});

Vue.use(BootstrapVueIcons);
Vue.use(vueWindowSize);

/**
 * Vue インスタンスの作成
 *
 * #Topic:
 * 必ずVue.use()するものはnew Vue()より前に実行しておくこと
 * new Vue()した後にUseしたものは、ブラウザの「更新」時にインスタンスが消えてしまう
 */
Vue.config.productionTip = false;
Vue.config.performance = process.env.NODE_ENV === "production" ? false : true;

new Vue({
  provide,
  router,
  store,
  render: (h) => h(App)
}).$mount("#app");
